const BoConfig = {
  sidebar: [
    {name:"Dashboard",link:"BoDashboard",icon:"ti-home"},
    {name:"Budgeting",link:"BoTrxBudgeting",icon:"ti-money"},
    {name:"Production",icon:"fa fa-edit",childs:[
        {name:"Client",link:"BoTrxClient"},
        {name:"Project",link:"BoTrxProject"},
        {name:"Document",link:"BoTrxDocument"},
    ]},
    {name:"Master Settings",icon:"ti-settings",childs:[
        {name:"Doc Access Type",link:"BoDocAccessType"},
        {name:"Doc Department",link:"BoDocDepartment"},
        {name:"Doc Type",link:"BoDocType"},
        {name:"Doc Product Type",link:"BoDocProductType"},
        {name:"Budget Cash Type",link:"BoBudgetCashType"},
        {name:"Budget Type",link:"BoBudgetType"},
        {name:"Budget Category",link:"BoBudgetCategory"},
    ]},
    {name:"User Management",icon:"ti-user",childs:[
        {name:"Users",link:"BoUsers"},
        {name:"User Level",link:"BoUserLevel"},
    ]}
  ],
}

export default BoConfig